import { getCachedFile, setFileCache } from '../file';
import { AbstractApi } from './Api';

export interface FileDownloadArgs {
  chat_id: string;
  cli_msg_id: string;
  meta: any;
}

export interface FileCancelArgs {
  cli_msg_id: string;
}

export class FileApi extends AbstractApi {
  async download({ chat_id, cli_msg_id, meta }: FileDownloadArgs, abortSignal?: AbortSignal) {
    let file = await getCachedFile(cli_msg_id);

    if (!file) {
      const [res, msg] = await Promise.all([
        this.client.invoke('fileTransferDownload', [chat_id, cli_msg_id, meta], abortSignal),
        this.client.Api.messages.getMsgByCliMsgId(chat_id, cli_msg_id, undefined, abortSignal),
      ]);

      if (!res || !msg) throw new Error('Failed to download file' + cli_msg_id);

      const binaryString = atob(res.file_data_base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      file = new File([bytes], msg.payload.name, {
        type: msg.payload.type,
      });

      setFileCache(cli_msg_id, file);
    }

    return file;
  }
  cancel({ cli_msg_id }: FileCancelArgs, abortSignal?: AbortSignal) {
    return this.client.invoke('cancelFileTransfer', [cli_msg_id], abortSignal);
  }
}
